<template>
  <v-card>
    <v-card-subtitle>
      Not Granted {{ titleName }}
    </v-card-subtitle>
    <v-divider :thickness="3" class="blue"></v-divider>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Application Amount
            </th>
            <th class="text-left">
              Due Date
            </th>
            <th class="text-left">
              Original Agreement Number
            </th>
            <th class="text-left">
              Original Agreement Date
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ subitem.ApplicationAmount !== '' ? `${subitem.CurrencyCode} ${toRupiah(subitem.ApplicationAmount)}` :
              '-' }}</td>
            <td>{{ subitem.DueDate !== '' ? subitem.DueDate : '-' }}</td>
            <td>{{ subitem.OriginalAgreementNumber !== '' ? subitem.OriginalAgreementNumber : '-' }}</td>
            <td>{{ subitem.OriginalAgreementDate !== '' ? subitem.OriginalAgreementDate : '-' }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: 'NoGrantedDisplay',
  props: ["subitem", "titleName"],

  methods: {
    toRupiah(rupiah) {
      var formattedNumber = parseFloat(rupiah).toLocaleString('en');
      return formattedNumber;
    }
  }
}
</script>